import * as Toastify from 'toastify-js'
import GenericResponse from '../../../react/Account/models/GenericResponse';
import { AjaxHelper } from '../../SharedLibrary/AjaxHelper';
import { IRequirementsModel } from '../Models/IRequirementsModel';

declare global {
    interface Window {
        bootstrap: any
    }
}

interface IGetRequirements {
    Success: boolean,
    TaskPart?: IRequirementsModel,
    Message?: string
}

export class GlobalMethods {
    public static HelloWorld(): void {
        console.log("Global Hello World");
    }

    public AddToast(toasts: Record<string, Toastify>, key: string, text: string) {
        toasts[key] = Toastify({
            text: text,
            position: "top-center",
            duration: -1,
        })
        return toasts;
    }

    public ShowToast(toasts: Record<string, Toastify>, key: string) {
        toasts[key].showToast()
    }

    public HideToast(toasts: Record<string, Toastify>, key: string) {
        toasts[key].hideToast()
    }

    public ShowSuccess(text: string, duration?: number) {
        duration = duration ?? 20;
        var key = "Notice-" + (Math.random() * 1000);
        window.toasts[key] = Toastify({
            text: "<span class='fa fa-check'></span>&nbsp;&nbsp;" + text,
            gravity: "top",
            position: "right",
            duration: duration * 1000,
            close: true,
            style: { background: "#d1e7dd", "border-color": "#badbcc", color: "#0f5132", padding: "1rem 1rem", "border-radius": "0.25rem", border: "1px solid transparent" },
            escapeMarkup: false
        });
        window.toasts[key].showToast();
    }

    public ShowMessage(text: string, duration?: number) {
        duration = duration ?? 20;
        var key = "Notice-" + (Math.random() * 1000);
        window.toasts[key] = Toastify({
            text: "<span class='fa fa-info-circle'></span>&nbsp;&nbsp;" + text,
            gravity: "top",
            position: "right",
            duration: duration * 1000,
            style: { background: "#cff4fc", "border-color": "#b6effb", color: "#055160", padding: "1rem 1rem", "border-radius": "0.25rem", border: "1px solid transparent" },
            escapeMarkup: false
        });
        window.toasts[key].showToast();
    }

    public ShowWarning(text: string, closeable: boolean, durationSeconds?: number) {
        var key = "Notice-" + (Math.random() * 1000);
        var duration = durationSeconds ?? 20;

        window.toasts[key] = Toastify({
            text: "<span class='fa fa-exclamation-triangle'></span>&nbsp;&nbsp;" + text,
            gravity: "top",
            position: "right",
            duration: duration * 1000,
            close: closeable,
            style: { background: "#fff3cd", "border-color": "#ffecb5", color: "#664d03", padding: "1rem 1rem", "border-radius": "0.25rem", border: "1px solid transparent" },
            escapeMarkup: false
        });
        window.toasts[key].showToast();
    }

    public ShowError(text: string, durationSeconds?: number) {
        var key = "Notice-" + (Math.random() * 1000);
        var duration = durationSeconds ?? 20;

        window.toasts[key] = Toastify({
            text: "<span class='fa fa-exclamation-circle'></span>&nbsp;&nbsp;" + text,
            gravity: "top",
            position: "right",
            duration: duration * 1000,
            close: true,
            style: { background: "#f8d7da", "border-color": "#f5c2c7", color: "#842029", padding: "1rem 1rem", "border-radius": "0.25rem", border: "1px solid transparent" },
            escapeMarkup: false
        });
        window.toasts[key].showToast();
    }

    public ShowBootstrapModal = (modalId: string) => {
        var popupModal = new window.bootstrap.Modal(document.getElementById(modalId), { backdrop: true, keyboard: true, focus: true })
        popupModal.show();
    }

    public ShowBootstrapModalStatic = (modalId: string) => {
        var popupModal = new window.bootstrap.Modal(document.getElementById(modalId), { backdrop: "static", keyboard: false, focus: true })
        popupModal.show();
    }

    public HideBootstrapModal = (modalId: string) => {
        var modal = window.bootstrap.Modal.getInstance(document.getElementById(modalId))
        modal.hide();
    }

    public GetRequirements(taskPartGuid: string) {
        const ajax = new AjaxHelper();
        return ajax.postRequest<IGetRequirements>("/api/tasktracker/taskpartrequirements", {
            TaskPartGuid: taskPartGuid
        });
    }

    public UserIsCourseOwner(courseID: number) {
        const ajax = new AjaxHelper();
        return ajax.getRequest<{ success: boolean, errorType: string, message: string }>("/api/Account/UserIsCourseOwner/" + courseID);
    }

    public UserIsCourseOwnerOrCoTeacher(courseID: number) {
        const ajax = new AjaxHelper();
        return ajax.getRequest<{ successful: boolean, errorType: string, message: string, isOwner: boolean, isCoTeacher: boolean }>("/api/Account/UserIsCourseOwnerOrCoTeacher/" + courseID);
    }
}